import axios from 'axios'

const client = axios.create({
  baseURL: process.env.VUE_APP_HOST + '/api/' + process.env.VUE_APP_COMPANY_TOKEN,
  timeout: 25000
})

export default client
